/**
 * Znacznik czasu w nagraniu albo w tekscie z czasami: "12:04", a od pelnej godziny "1:25:54"
 * (jak w tekscie wejsciowym i w pliku Word, a nie "85:54"). Wspolny dla dymkow i wiadomosci systemowych.
 */
export function mmss(ms: number): string {
  const sekundy = Math.max(0, Math.round(ms / 1000));
  const dwie = (n: number): string => String(n).padStart(2, "0");
  const godziny = Math.floor(sekundy / 3600);
  const minuty = Math.floor((sekundy % 3600) / 60);
  const reszta = sekundy % 60;
  return godziny > 0 ? `${godziny}:${dwie(minuty)}:${dwie(reszta)}` : `${minuty}:${dwie(reszta)}`;
}
